import {BaseEndpoints} from 'public-shared/models/endpoints/base-endpoint.constants';

export class LoggerEndpoints {
  public static readonly BASE = BaseEndpoints.V1 + 'log/';
  public static readonly ERROR = 'error/';
  public static readonly INFO = 'info/';
  public static readonly WARN = 'warn/';
}
